import {Card, Paper} from "@mui/material";
import useSWR from "swr";
import {fetchData} from "../../../lib/dashboard/data";
import {CustomKeyTypography} from "./TransactionComponentStyles";
import Table from "../../../components/table/Table";
import React from "react";
import {faCols_transition} from "../../../components/tableHeaderNames/HeaderName";

const Transaction = () => {

    // get all transactions
    const data = useSWR("/account/receipts", fetchData, {
        revalidateOnFocus: false,
    });

    const highlightedCols = [
        "is_confirmed",
    ]

    return (
        <Paper
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "100%",
                height: "calc(100vh - 120px)",
            }}
        >
            <CustomKeyTypography sx={{fontSize: "16px", fontWeight: 700}}>
                تراکنش‌های اخیر
            </CustomKeyTypography>
            <Card sx={{height: "100%"}}>
                <Table
                    tableData={data}
                    tableTitle={{
                        title: "تراکنش‌ها",
                        desc: "تمامی تراکنش‌های شما",
                    }}
                    faCols={faCols_transition}
                    highlightedCols={highlightedCols}
                    height={"88vh"}
                />
            </Card>
        </Paper>
    );
};

export default Transaction;